import { Component, OnInit } from '@angular/core';
import { SharedStateService } from '../../../shared/services/shared-state.service';

@Component({
  selector: 'app-product-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss'],
  standalone: false,
})
export class SideNavComponent implements OnInit {
  adiabaticEfficiency = true;
  totalEfficiency = true;
  heatRecoveryUsed = true;

  motorOptions = [
    { label: '400 kW', checked: false },
    { label: '500 kW', checked: false },
    { label: '580 kW (Switch)', checked: false },
    { label: '650 kW (ABB)', checked: true },
  ];

  constructor(private sharedStateService: SharedStateService) {}

  onHeatRecoveryToggle(): void {
    this.sharedStateService.setHeatRecoveryUsed(this.heatRecoveryUsed);
  }

  onAdiabaticEfficiencyToggle(): void {
    this.sharedStateService.setAdiabaticEfficiency(this.adiabaticEfficiency);
  }

  onTotalEfficiencyToggle(): void {
    this.sharedStateService.setTotalEfficiency(this.totalEfficiency);
  }

  onMotorOptionChange(option: string, checked: boolean): void {
    switch (option) {
      case '400 kW':
        this.sharedStateService.setMotor400kW(checked);
        break;
      case '500 kW':
        this.sharedStateService.setMotor500kW(checked);
        break;
      case '580 kW (Switch)':
        this.sharedStateService.setMotor580kW(checked);
        break;
      case '650 kW (ABB)':
        this.sharedStateService.setMotor650kW(checked);
        break;
    }
  }

  ngOnInit(): void {
    this.sharedStateService.setHeatRecoveryUsed(this.heatRecoveryUsed);
  }

  getSelectedOptions() {
    const selectedMotors = this.motorOptions.filter((option) => option.checked).map((option) => option.label);

    return {
      adiabaticEfficiency: this.adiabaticEfficiency,
      totalEfficiency: this.totalEfficiency,
      heatRecoveryUsed: this.heatRecoveryUsed,
      selectedMotors,
    };
  }
}
